var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15293_35455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.61117C10.8333 3.15093 10.4602 2.77783 9.99999 2.77783C9.53976 2.77783 9.16666 3.15093 9.16666 3.61117V11.0438L7.25592 9.13302C6.93048 8.80758 6.40284 8.80758 6.0774 9.13302C5.75197 9.45846 5.75197 9.9861 6.0774 10.3115L9.41074 13.6449C9.73618 13.9703 10.2638 13.9703 10.5893 13.6449L13.9226 10.3115C14.248 9.98609 14.248 9.45846 13.9226 9.13302C13.5971 8.80758 13.0695 8.80758 12.7441 9.13302L10.8333 11.0438V3.61117Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2222 14.1667C17.2222 13.7065 16.8491 13.3334 16.3889 13.3334C15.9286 13.3334 15.5555 13.7065 15.5555 14.1667V15.0556C15.5555 15.5158 15.1825 15.8889 14.7222 15.8889L5.27777 15.8889C4.81753 15.8889 4.44444 15.5158 4.44444 15.0556L4.44444 14.1667C4.44444 13.7065 4.07134 13.3334 3.6111 13.3334C3.15087 13.3334 2.77777 13.7065 2.77777 14.1667V15.0556C2.77777 16.4363 3.89706 17.5556 5.27777 17.5556L14.7222 17.5556C16.1029 17.5556 17.2222 16.4363 17.2222 15.0556V14.1667Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15293_35455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default __webpack_public_path__ + "static/media/iconDownload2.503840186a94ebd73ae2630beef27c42.svg";
export { ForwardRef as ReactComponent };